export const selectUtilityList = (state) => state.Utility.utilityList;
export const selectUtility = (state) => state.Utility.currentUtility;
export const selectIsLoading = (state) => state.Utility.isLoading;
export const selectError = (state) => state.Utility.error;
